<script lang="ts">
	import type { ClassValue } from 'svelte/elements';

	interface Props {
		text?: string;
		isHidden?: boolean;
		ariaHidden?: boolean;
		id?: string;
		class?: ClassValue;
	}

	const {
		text,
		isHidden = false,
		ariaHidden = false,
		id,
		class: classes,
	}: Props = $props();
</script>

{#if text && !isHidden}
	<span
		{id}
		class={['text-sm text-coloredneutral-weak', classes]}
		data-testid="helper-text"
		aria-hidden={ariaHidden}>{text}</span
	>
{/if}
